import { combineReducers } from 'redux'
import auth from './auth/reducer'
import layout from './layout/reducer'
import notification from './notification/reducer'
import projects from './projects/reducer'
import projectTypes from './projects/projectTypeReducer'
import metadata from './metadata/reducer'
import tmList from './teamMemberList/reducer'
import boards from './boards/reducer'
import uploads from './uploads/reducer'
// TODO rename later once basic flow completed.
import assetsSearch from './search/reducer'
import userPreferences from './preferences/reducer'
import userPublish from './publishUpload/users/userReducer'
import headerReducer from './header/reducer'
import assetClassificationReducer from './classification/reducer'
import tableContextReducer from './tableContext/reducer'

//BetaSearch Store
import searchReducer from '../betasearch/store/search/searchSlice'
import userPreferenceReducer from '../betasearch/store/preference/userPreferenceSlice'
import metadataReducer from '../betasearch/store/metadata/metadataSlice'

// Feature-owned reducers are injected with their route or nested feature.
// See components/Layout/routes.js and settings/pages/SettingsLandingPage.js.
export const staticReducers = {
  auth,
  boards,
  layout,
  notification,
  projects,
  metadata,
  tmList,
  projectTypes,
  uploads,
  assetsSearch,
  userPreferences,
  userPublish,
  headerReducer,
  assetClassificationReducer,
  tableContextReducer,
  newSearch: searchReducer,
  newUserPreference: userPreferenceReducer,
  newMetadata: metadataReducer,
}

export const createReducer = (asyncReducers = {}) =>
  combineReducers({
    ...staticReducers,
    ...asyncReducers,
  })

export default createReducer
